import { makeObservable } from 'mobx'
import type { MobxDocument } from '../firestore-mobx'
import {
  ObservableModelWithDecorators,
  emptyCollection,
  emptyModel,
} from '../firestore-mobx/model'
import {
  empty,
  type FirestoreRoomStateUPRPeerReview,
} from '../firestore/RoomStateUPRPeerReview/schema'
import type { FirebaseRepository } from './FirebaseRepository'

export class RoomStateUPRPeerReview extends ObservableModelWithDecorators<FirestoreRoomStateUPRPeerReview> {
  static empty(repository: FirebaseRepository) {
    return emptyModel(repository, this, empty)
  }

  static emptyCollection(repository: FirebaseRepository) {
    return emptyCollection(repository, this, empty)
  }

  constructor(
    repository: FirebaseRepository,
    doc: MobxDocument<FirestoreRoomStateUPRPeerReview>
  ) {
    super(repository, doc)
    makeObservable(this)
  }
}

/** You don't have to use these, but they make manipulating the database scores more explicit */
export const PeerReviewMeaningfulScore = {
  ExceededExpectations: 'ExceededExpectations', // DB: 3
  MetExpectations: 'MetExpectations', // DB: 2
  NeedsSupport: 'NeedsSupport', // DB: 1
  NA: 'NA', // DB: 0
} as const
export type PeerReviewMeaningfulScore =
  (typeof PeerReviewMeaningfulScore)[keyof typeof PeerReviewMeaningfulScore]

export const peerReviewMeaningfulScoreFromDBValue = (
  dbValue: number
): PeerReviewMeaningfulScore => {
  if (dbValue === 0) return PeerReviewMeaningfulScore.NA
  if (dbValue === 1) return PeerReviewMeaningfulScore.NeedsSupport
  if (dbValue === 2) return PeerReviewMeaningfulScore.MetExpectations
  if (dbValue === 3) return PeerReviewMeaningfulScore.ExceededExpectations
  throw new Error(`Invalid DB value: ${dbValue}`)
}

export const peerReviewScoreProperties = {
  [PeerReviewMeaningfulScore.ExceededExpectations]: {
    longLabel: 'Exceeded Expectations',
    label: 'Exceeded Expectations',
    numericalValue: 3,
    DBValue: 3,
  },
  [PeerReviewMeaningfulScore.MetExpectations]: {
    longLabel: 'Met Expectations',
    label: 'Met Expectations',
    numericalValue: 2,
    DBValue: 2,
  },
  [PeerReviewMeaningfulScore.NeedsSupport]: {
    longLabel: 'Needs Support',
    label: 'Needs Support',
    numericalValue: 1,
    DBValue: 1,
  },
  [PeerReviewMeaningfulScore.NA]: {
    longLabel: 'Not Applicable (N/A)',
    label: 'N/A',
    numericalValue: undefined,
    DBValue: 0,
  },
} as const // For colors, use peerReviewScoreColor
